import React from 'react';
import Thumbnail from './Thumbnail';
import Small from './Small';
import Basic from './Basic';

const DocumentPreview = ({
  document,
  type,
  onCrop,
  onClick,
  zoomablePDF,
  onFileError,
  editDisabled
}) => {
  const { id, documentUrl, attachmentContentType } = document || '';
  const customProps = {
    src: documentUrl,
    attachmentType: attachmentContentType,
    onClick
  };
  switch (type) {
    case 'thumbnail':
      return <Thumbnail {...customProps} />;
    case 'small':
      return (
        <Small
          {...customProps}
          id={id}
          onCrop={onCrop}
          onFileError={onFileError}
          editDisabled={editDisabled}
        />
      );
    default:
      return (
        <Basic
          {...customProps}
          onCrop={onCrop}
          zoomablePDF={zoomablePDF}
          editDisabled={editDisabled}
        />
      );
  }
};

export default DocumentPreview;



// WEBPACK FOOTER //
// ./src/component/DocumentPreview/index.js